import { render, staticRenderFns } from "./UserEvent.vue?vue&type=template&id=127c9934"
import script from "./UserEvent.vue?vue&type=script&lang=js"
export * from "./UserEvent.vue?vue&type=script&lang=js"
import style0 from "./UserEvent.vue?vue&type=style&index=0&id=127c9934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports